// extracted by mini-css-extract-plugin
export default {"wrapper":"ResponseTextarea_wrapper__R0App","response_textarea":"ResponseTextarea_response_textarea__Cy6AO"};